import { PicksView } from '../../../components/worldcup/PicksView/PicksView';

export default function WorldCupIndex() {
  return <PicksView />;
}
